import { Route } from "react-router-dom";
import { CADPage, ElectricalPage, FireProtectionPage, HelpPage, MechanicalPage, PlumbingPage } from "../Resource/ResourcePage";

export const RESOURCE_ROUTES = [
    <Route key="resources-mechanical" path="/resources/mechanical" element={<MechanicalPage />} />,
    <Route key="resources-electrical" path="/resources/electrical" element={<ElectricalPage />} />,
    <Route key="resources-plumbing" path="/resources/plumbing" element={<PlumbingPage />} />,
    <Route key="resources-fire-protection" path="/resources/fire_protection" element={<FireProtectionPage />} />,
    <Route key="resources-cad" path="/resources/cad" element={<CADPage />} />,
    <Route key="resources-help" path="/resources/help" element={<HelpPage />} />
];
